export const TILLS = ["Pro Shop", "Grill", "Masters Bar"];

export const FLOAT = { "Pro Shop": 300, "Grill": 150, "Masters Bar": 300 };
export const TIP_FLOAT_BOX = 375;  // cash in the shared, locked tip float box
export const ZLINE = { "Pro Shop": "NET3", "Grill": "DRWR TTL", "Masters Bar": "NET3" };
export const CARDLINE = { "Pro Shop": "Credit C", "Grill": "VISA SALES", "Masters Bar": "Credit C" };
export const TERMINAL = { "Pro Shop": "A2086774", "Grill": "A2056543", "Masters Bar": "Shared with Grill — keep card receipts" };

export const TILL_LABEL = {
  "Pro Shop": "Pro Shop",
  "Grill": "Makwa Grill",
  "Masters Bar": "Masters Bar",
};

export const MODES = [
  { id: "morning", label: "Morning / opening count", icon: "sunrise", blurb: "Count the drawer, compare to the till float." },
  { id: "end_of_day", label: "End-of-day close (Z)", icon: "moon", blurb: "Full close — photos, math, deposit." },
  { id: "shift_change", label: "Shift change (X)", icon: "refresh", blurb: "Hand off — cash stays in the drawer." },
  { id: "just_count", label: "Just count the till", icon: "calculator", blurb: "Quick count. Nothing is saved." },
];

export const DENOMS = [
  { key: "b100",    label: "$100",   value: 100 },
  { key: "b50",     label: "$50",    value: 50 },
  { key: "b20",     label: "$20",    value: 20 },
  { key: "b10",     label: "$10",    value: 10 },
  { key: "b5",      label: "$5",     value: 5 },
  { key: "toonie",  label: "Toonie", value: 2 },
  { key: "loonie",  label: "Loonie", value: 1 },
  { key: "quarter", label: "Quarter",value: 0.25 },
  { key: "dime",    label: "Dime",   value: 0.10 },
  { key: "nickel",  label: "Nickel", value: 0.05 },
];

// Reasons the till might be over or short, picked at close time.
export const SHORTAGE_REASONS = [
  { id: "tips_from_till",         label: "Tips paid out of the till cash (should be from tip float box)" },
  { id: "refund_instead_of_void", label: "Refund done instead of a void" },
  { id: "card_rung_as_cash",      label: "A card sale was rung in as cash" },
  { id: "cash_rung_as_card",      label: "A cash sale was rung in as card" },
  { id: "wrong_change",           label: "Wrong change given out" },
  { id: "missed_transaction",     label: "A sale wasn't rung in" },
  { id: "comp_or_discount",       label: "Comp/discount not entered properly" },
  { id: "float_borrowed",         label: "Someone used the till float" },
  { id: "drawer_left_open",       label: "Drawer left open between sales" },
  { id: "other",                  label: "Other — explain below" },
];

export const GROUPS = [
  { key: "green_fees", label: "Green fees",       pro_shop: true },
  { key: "pro_shop",   label: "Pro shop",         pro_shop: true },
  { key: "rentals",    label: "Rentals (cart)",   pro_shop: true },
  { key: "restaurant", label: "Restaurant / Food",pro_shop: false },
  { key: "alcohol",    label: "Alcohol / Liquor", pro_shop: false },
  { key: "beer",       label: "Beer",             pro_shop: false },
];

// Per-till department schemas. Each register prints its own labels — the Grill
// prints GROUP totals (1, 2, 4, 5, 6, 7); the Pro Shop prints DEPT D02–D14
// with more granular labels (Cart Rental, Club Rental, Range Ball, etc.).
export const DEPARTMENTS = {
  "Pro Shop": [
    { key: "memberships",   label: "Memberships",   code: "D01" },
    { key: "green_fees",    label: "Green fees",    code: "D02" },
    { key: "cart_rental",   label: "Cart rental",   code: "D03" },
    { key: "club_rental",   label: "Club rental",   code: "D04" },
    { key: "range_ball",    label: "Range balls",   code: "D05" },
    { key: "misc_golf",     label: "Misc golf",     code: "D06" },
    { key: "oga_fees",      label: "OGA fees",      code: "D07" },
    { key: "trail_fees",    label: "Trail fees",    code: "D08" },
    { key: "d09",           label: "D09 (TBD)",     code: "D09" },
    { key: "confectionary", label: "Confectionary", code: "D10" },
    { key: "food",          label: "Food",          code: "D11" },
    { key: "d12",           label: "D12 (TBD)",     code: "D12" },
    { key: "pop",           label: "Pop",           code: "D13" },
    { key: "water",         label: "Water",         code: "D14" },
    { key: "beer",          label: "Beer",          code: "D15" },
  ],
  "Grill": [
    { key: "green_fees",  label: "Green fees",  group: "1" },
    { key: "pro_shop",    label: "Pro shop",    group: "2" },
    { key: "memberships", label: "Memberships", group: "3" },
    { key: "rentals",     label: "Rentals",     group: "4" },
    { key: "restaurant",  label: "Restaurant",  group: "5" },
    { key: "alcohol",     label: "Alcohol",     group: "6" },
    { key: "beer",        label: "Beer",        group: "7" },
  ],
  // Masters Bar register prints DEPT codes like the Pro Shop — real labels TBD.
  "Masters Bar": [
    { key: "mb_d01", label: "D01 (TBD)", code: "D01" },
    { key: "mb_d02", label: "D02 (TBD)", code: "D02" },
    { key: "mb_d03", label: "D03 (TBD)", code: "D03" },
    { key: "mb_d04", label: "D04 (TBD)", code: "D04" },
    { key: "mb_d05", label: "D05 (TBD)", code: "D05" },
    { key: "mb_d06", label: "D06 (TBD)", code: "D06" },
    { key: "mb_d07", label: "D07 (TBD)", code: "D07" },
    { key: "mb_d08", label: "D08 (TBD)", code: "D08" },
    { key: "mb_d09", label: "D09 (TBD)", code: "D09" },
    { key: "mb_d10", label: "D10 (TBD)", code: "D10" },
    { key: "mb_d11", label: "D11 (TBD)", code: "D11" },
    { key: "mb_d12", label: "D12 (TBD)", code: "D12" },
    { key: "mb_d13", label: "D13 (TBD)", code: "D13" },
    { key: "mb_d14", label: "D14 (TBD)", code: "D14" },
    { key: "mb_d15", label: "D15 (TBD)", code: "D15" },
  ],
};
export const SHORTAGE_CHECKS = [
  { key: "refund_check",    label: "Did anyone do a REFUND today? (Refunds move cash out — a void would not.)" },
  { key: "void_check",      label: "Was a void run correctly (before the receipt printed)?" },
  { key: "cash_card_check", label: "Could a card sale have been rung as cash, or vice versa?" },
  { key: "float_check",     label: "Did anyone borrow from or top up the till float?" },
  { key: "tip_check",       label: "Was any cash taken out for tips (it shouldn't have been)?" },
  { key: "change_check",    label: "Any chance wrong change was handed back on a big bill?" },
];
